var _defs, _path, _path2, _path3, _path4, _polyline, _path5, _polyline2, _path6, _polyline3, _path7, _polyline4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBandage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#323232;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,1.02944h0a4.24264,4.24264,0,0,1,4.24264,4.24264V18.72792A4.24264,4.24264,0,0,1,12,22.97056h0a4.24264,4.24264,0,0,1-4.24264-4.24264V5.27207A4.24263,4.24263,0,0,1,12,1.02944Z",
    transform: "translate(-4.97056 12.00002) rotate(-45.00005)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18,12l1.75736-1.75736a4.24265,4.24265,0,0,0,0-6h0a4.24264,4.24264,0,0,0-6,0L12,6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,12,4.24264,13.75736a4.24265,4.24265,0,0,0,0,6h0a4.24264,4.24264,0,0,0,6,0L12,18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.0005,10,12,9.9995,11.9995,10"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "12 10 12 10.001 12 10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.0005,14,12,13.9995,11.9995,14"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "12 14 12 14.001 12 14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,12.0005,14.0005,12,14,11.9995"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "14 12 13.999 12 14 12"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10,12.0005,10.0005,12,10,11.9995"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "10 12 9.999 12 10 12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandage1);
export default __webpack_public_path__ + "static/media/bandage-1.e375f57147792c176e5fa1474a557692.svg";
export { ForwardRef as ReactComponent };